<!--content of this component is only rendered only for dev and default environment-->
<ng-container *ngIf="isDevelopmentMode()">
    <ng-content></ng-content>
</ng-container>

